import { Button, CheckCard } from "@/components";
import { FONT, RADIUS } from "@/styles/common";
import { getDefaultParameters } from "@/utils";
import { Divider, Flex, Spinner, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { LOCAL_STORAGE, useCompletedRoomState, useNewNavigate, usePaidMethodRecoilValue } from "@shared/client";
import { usePostBookingConfirm } from "@shared/server";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CompleteCatchPraise } from "../components";

export const CompleteMobile = () => {
    const [completedRoom, setCompleteRoom] = useCompletedRoomState();
    const [isLoading, setIsLoading] = useState(true);
    const paidMethodValue = usePaidMethodRecoilValue();
    const [searchParams] = useSearchParams();
    const { mutate } = usePostBookingConfirm();
    const { onNavigate } = useNewNavigate();
    const idx = getDefaultParameters().idx;
    const merchant_uid = searchParams.get("merchant_uid");
    const imp_uid = searchParams.get("imp_uid");
    const imp_success = searchParams.get("imp_success");
    const sessionCompletedData = sessionStorage.getItem(merchant_uid as string);
    const paidMethodFromSessionStorage = sessionStorage.getItem("paidMethod");

    useEffect(() => {
        if (paidMethodValue) sessionStorage.setItem("paidMethod", paidMethodValue);
    }, [paidMethodValue]);

    useEffect(() => {
        if (merchant_uid) {
            const orderNumMessageCount = LOCAL_STORAGE.get({ key: `${merchant_uid}_count` });
            if (sessionCompletedData) {
                setCompleteRoom(JSON.parse(sessionCompletedData));
                return;
            }

            if (orderNumMessageCount === "0" || orderNumMessageCount === null) {
                if (imp_success === "true") {
                    const successData = {
                        co_id: getDefaultParameters().co_id,
                        idx: Number(idx),
                        imp_uid,
                        status: "complete",
                        orderNum: merchant_uid,
                    };

                    mutate(successData, {
                        onSuccess: (res) => {
                            LOCAL_STORAGE.set({ key: `${merchant_uid}_count`, value: "1" });
                            sessionStorage.setItem(`${merchant_uid}`, JSON.stringify(res));
                            setCompleteRoom(res);
                            setIsLoading(false);
                        },
                    });
                } else if (imp_success === "false") {
                    const errorData = {
                        co_id: getDefaultParameters().co_id,
                        idx: Number(idx),
                        status: "error",
                        orderNum: merchant_uid,
                    };

                    mutate(errorData, {
                        onSuccess: () => {
                            setIsLoading(false);
                            alert("결제 도중 오류 발생! 다시 처음부터 진행 해주세요.");
                            onNavigate({ path: "/reserve" });
                        },
                    });
                }
            }
        }
    }, []);

    if (isLoading && !sessionCompletedData) {
        return (
            <Flex flexDir="column">
                서버에 최종 결제처리중 입니다...
                <Spinner />
            </Flex>
        );
    }
    return completedRoom ? (
        <Flex w="100%" alignItems="flex-start" flexDir="column" gap="24px">
            <CustomCompletedPaidText>
                {paidMethodValue === "account" || paidMethodFromSessionStorage === "account"
                    ? "신청 완료"
                    : "예약 완료"}
            </CustomCompletedPaidText>
            <CustomFlex w="100%" padding="24px" flexDir="column" gap="24px">
                <Flex w="100%" flexDir="column" rowGap="32px">
                    {completedRoom.roomList.map((room) => (
                        <CheckCard key={room.roomName} roomList={room} status={completedRoom.status} />
                    ))}
                </Flex>
                <CustomDivider />
                <CompleteCatchPraise
                    orderNum={completedRoom.orderNum}
                    orderName={completedRoom.orderName}
                    roomList={completedRoom.roomList}
                    pay_memo={completedRoom.pay_memo}
                    payMethod={completedRoom.payMethod}
                />
            </CustomFlex>
        </Flex>
    ) : (
        <Flex flexDir="column">
            <Text>oops...! 세션이 만료 되었어요.</Text>
            <Button onClick={() => onNavigate({ path: "/status" })}>예약페이지로 가기</Button>
        </Flex>
    );
};

const CustomCompletedPaidText = styled(Text)`
    ${FONT("pretendard", 24, 700)}
`;

const CustomFlex = styled(Flex)`
    border: 1px solid;
    border-color: ${({ theme }) => theme.COLOR.gray[300]};
    ${RADIUS(4)}
`;

const CustomDivider = styled(Divider)`
    color: ${({ theme }) => theme.COLOR.gray[300]};
`;
